// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3X_Ov","inputWrap":"CustomTip_inputWrap__wbWSR"};